module.exports = __webpack_public_path__ + "static/media/lungs.f8c7ffe4.svg";